import React from 'react';
import FlipCard from './FlipCard';
import './LeadershipExperience.css';

const LeadershipExperience = () => {
  const leadershipData = [
    {
      title: "University of Michigan Panhellenic Council",
      subtitle: "Director of Operations",
      date: "March 2022 – January 2023",
      location: "Ann Arbor, MI",
      front: "Led operations for the largest sorority recruitment in the Big Ten, managing logistics for 1150+ potential new members across 16 chapter houses.",
      back: [
        "Optimized route efficiency and secured bussing system for full-cycle sorority recruitment, safely transporting 1150+ potential new members between 16 chapter houses.",
        "Facilitated the Panhellenic Ambassador program, placing upperclassmen sorority members around campus during recruitment to answer questions and be of assistance.",
        "Organized the recruitment and training process for 40+ volunteers in the Panhellenic Ambassador program, ensuring safety protocols were established for all chapters."
      ]
    },
    {
      title: "University of Michigan Fraternity and Sorority Life",
      subtitle: "Member, Social Responsibility Committee",
      date: "August 2021 - January 2022",
      location: "Ann Arbor, MI",
      front: "Enforced university policies and promoted student safety initiatives for a community of 5000+ Greek Life members across 32 chapter houses.",
      back: [
        "Enforced university-wide policies and regulations at registered social events, promoting student safety initiatives for a community of 5000+ Greek Life active members.",
        "Conducted random security and routine checks of 32 chapter houses on campus, reporting any violations of university policy to the executive faculty committee.",
        "Presented reports and updates of the committee to the Fraternity and Sorority Life council, contributing to strategic planning and future initiatives for all 32 chapters."
      ]
    },
    {
      title: "Delta Phi Epsilon Sorority, Delta Eta Chapter",
      subtitle: "Secretary",
      date: "August 2021 – August 2022",
      location: "Ann Arbor, MI",
      front: "Managed administrative operations for a chapter of 125+ members, implementing new systems for attendance tracking and record management.",
      back: [
        "Created a new attendance tracking system using Microsoft Office 365 for a chapter of 125+ members, ensuring participation at all sorority events was well-tracked and organized.",
        "Managed agenda and minutes for executive board and chapter-wide meetings, condensing complex discussions and ideation for member newsletter and updates.",
        "Compiled personal records for all active members and organized chapter-wide composite photography sessions, negotiating and handling any issues with the photography company."
      ]
    },
    {
      title: "K-grams",
      subtitle: "Letter Liaison",
      date: "September 2021 - May 2022",
      location: "Ann Arbor, MI",
      front: "Facilitated a penpal program connecting University of Michigan students with local elementary and middle school students.",
      back: [
        "Facilitated a penpal program between University of Michigan students and Ann Arbor elementary/middle schoolers.",
        "Assigned penpals and collected and delivered letters monthly."
      ]
    }
  ];

  return (
    <section id="leadership" className="section leadership-experience">
      <h2 className="section-title">Leadership Experience</h2>
      <div className="cards-container">
        {leadershipData.map((leadership, index) => (
          <FlipCard
            key={index}
            title={leadership.title}
            subtitle={leadership.subtitle}
            date={leadership.date}
            location={leadership.location}
            front={leadership.front}
            back={leadership.back}
            animationDelay={index * 150} // Staggered delay: 0ms, 150ms, 300ms, etc.
          />
        ))}
      </div>
    </section>
  );
};

export default LeadershipExperience;
